// extracted by mini-css-extract-plugin
module.exports = {"containerColumns":"styles_containerColumns__2cPtN","column":"styles_column__3bQjU","columnTitle":"styles_columnTitle__3mYab"};